import React, { useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";


const LaundryMasterPopup = ({ data, data1 }) => {
  
  const [branchProjectBindDD, setbranchProjectBindDD] = useState([]);
  const [bindMedicinesDrugsDD, setBindMedicinesDrugsDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);

  return (
    <div class="w-full">
      <div class={mainTable.mainContentScreen}>
      <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div class={mainTable.labelBold}>Company Details</div>
          <hr class={mainTable.horizontalLine}></hr>
          <div class="grid gap-4 mb-6 md:grid-cols-3">
            <div>
              <InputText
                inputType={"text"}
                title={" Company Id"}
                name={" CompanyId"}
                content={data.LaundryCompanyId}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"text"}
                title={"Company Name"}
                name={"customername"}
                content={data.LaundryCompany}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"text"}
                title={"Address"}
                name={"address"}
                content={data.Address}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <AutoDropDown
                title="Country"
                options={countryBindDD}
                placeholder="Select"
                name="state"
                selectedOption={{value : data.MstCountryId, label:data.CountryName}}
                Class="custom-class"
                // tabIndex="1"
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>

            <div>
              <AutoDropDown
                title="State"
                options={stateBindDD}
                placeholder="Select"
                name="state"
                selectedOption={[data1[1]]}
                Class="custom-class"
                // tabIndex="1"
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <AutoDropDown
                title="City"
                options={branchProjectBindDD}
                placeholder="Select"
                name="branchProject"
                 // selectedOption={[data1[2]]}
                 selectedOption={{value : data.MstCityId, label:data.City}}
                Class="custom-class"
                // tabIndex="1"
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"number"}
                title={"Pin Code"}
                name={"pincode"}
                content={data.Pincode}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType="date"
                title="Date"
                name="date"
                content={[data1[4]]}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>

            

            <div className="flex">
              <div>
                <img
                  src={data.FileUpload}
                  alt="Image"
                  className="w-20 h-20"
                />
              </div>
            </div>
          </div>
          <div class={mainTable.labelBold}>Contact Info</div>
          <hr class={mainTable.horizontalLine}></hr>
          <div class="grid gap-4 mb-6 md:grid-cols-3">
            <div>
              <InputText
                inputType={"text"}
                title={"Contact Person"}
                name={"contactperson"}
                content={data.ContactPerson}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"text"}
                title={"Designation"}
                name={"designation"}
                content={data.Designation}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"text"}
                title={"Mobile Number"}
                name="mobileNumber"
                content={data.MobileNumber}
                disabled="disabled"
                classStar="text-red-500"
              />
            </div>
            <div>
              <InputText
                inputType={"text"}
                title={"Email"}
                name="EmailId"
                content={data.EmailId}
                disabled="disabled"
                // classStar="text-red-500"
              />
            </div>
            <div class="lg:col-span-3 sm:col-span-1">
              <div class={mainTable.input_richtextbox}></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LaundryMasterPopup;